import React from 'react';
import { Link } from 'react-router-dom';

import SplashExplanationIcons from './SplashExplanationIcons';

function SplashExplanation() {
  return (
    <div className="splash-explanation">
      <div className="row">
        <h2 className="splash-explanation__heading">
          HOW TO USE THIS TOOL
        </h2>
        <div className="text splash-explanation__text">
          <p>
            This tracer activity includes targeted questions and observations for practices in the hospital pharmacy, nursing units (for example, medical/surgical, telemetry, critical care), emergency department, operating rooms, and procedural areas supported by anesthesia providers (for example, interventional radiology, gastroenterology procedures areas, cardiac catheterization procedure areas, ambulatory surgery, obstetrical operating&nbsp;rooms).
          </p>
          <p>
            In order to thoroughly assess injectable medication practices, the tracers should be conducted on multiple nursing units, operating rooms, and procedural areas to help identify patterns, trends, and variations in practices with injectable medications throughout the organization. Each set of observations should take approximately 20 to 30&nbsp;minutes.
          </p>
        </div>
      </div>
      <div className="row splash-explanation__callouts">
        <div className="splash-explanation__callout">
          <SplashExplanationIcons name="baseline" />
          <h3 className="splash-explanation__subheading">
            Set a Baseline
          </h3>
          <p className="splash-explanation__caption">
            This assessment utilizes tracer methodology which relies on observation, document review, and interviews to understand the current state of practices and identify opportunities for&nbsp;improvement.
          </p>
        </div>
        <div className="splash-explanation__callout">
          <SplashExplanationIcons name="plan" />
          <h3 className="splash-explanation__subheading">
            Make an Action Plan
          </h3>
          <p className="splash-explanation__caption">
            Using insights gained from your assessments, outline steps your hospital can take towards providing injectable medications in the most ready-to-administer forms&nbsp;possible.
          </p>
        </div>
        <div className="splash-explanation__callout">
          <SplashExplanationIcons name="progress" />
          <h3 className="splash-explanation__subheading">
            Track Progress
          </h3>
          <p className="splash-explanation__caption">
            Many injectable medication practices change over time for varying reasons, including medication shortages. Therefore, use this tool periodically to reassess injectable medication&nbsp;processes.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="splash-explanation__button-wrapper">
          <Link to="login" className="button button--brand button--large">
            Start New Assessment
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SplashExplanation;



// WEBPACK FOOTER //
// ./src/components/features/splash/SplashExplanation.js